import { createTheme } from "@mui/material/styles";

const fastFoodTheme = createTheme({
  palette: {
    primary: {
      main: "#FF6B6B",
      light: "#FF8C8C",
      dark: "#FF4A4A",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#FF8C00",
      light: "#FFA533",
      dark: "#CC7000",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#fff",
      paper: "#ff",
    },
    text: {
      primary: "#111111",
      secondary: "#222222",
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: "3.75rem",
      lineHeight: 1.1,
    },
    h2: {
      fontWeight: 800,
      fontSize: "3rem",
      lineHeight: 1.2,
    },
    h3: {
      fontWeight: 700,
      fontSize: "2.25rem",
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.1rem",
      lineHeight: 1.4,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.6,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "100px",
          padding: "12px 24px",
          fontWeight: 700,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
          },
        },
        contained: {
          "&:hover": {
            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          },
        },
      },
    },
  },
});

export default fastFoodTheme;
